import { render } from "./MatrixSupportNetwork.vue?vue&type=template&id=03232478&scoped=true"
import script from "./MatrixSupportNetwork.vue?vue&type=script&lang=js"
export * from "./MatrixSupportNetwork.vue?vue&type=script&lang=js"

import "./MatrixSupportNetwork.vue?vue&type=style&index=0&id=03232478&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03232478"]])

export default __exports__